export const MuiCssBaseline = () => ({
  '@global': {
    body: {
      fontFamily: 'Nunito'
    }
  }
});
